<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4Zh2ZI/tc-custom/9781429922142.jpg?1731007755151" alt="This image is the cover for the book Captain Pantoja and the Special Service"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Captain Pantoja and the Special Service
      </h1>
      <p class="bookDescription body article font2">
        <p>This delightful farce opens as the prim and proper Captain Pantoja learns he is to be sent to Peru's Amazon frontier on a secret mission for the army—to provide females for the amorous recruits. Side-splitting complications arise as world of Captain Pantoja's remarkable achievements start to spread.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mario Vargas Llosa
      </h2>
      
      <p class="authorDescription body article"><P><B>Mario Vargas Llosa</B> is Peru's foremost author and the winner of the 2010 Nobel Prize in Literature. In 1994 he was awarded the Cervantes Prize, the Spanish-speaking world's most distinguished literary honor, and in 1995 he won the Jerusalem Prize. His many distinguished works include <I>The Storyteller</I>, <I>The Feast of the Goat</I>, <I>Aunt Julia and the Scriptwriter</I>, <I>Death in the Andes</I>, <I>In Praise of the Stepmother</I>, <I>The Bad Girl</I>, <I>Conversation in the Cathedral</I>, <I>The Way to Paradise</I>, and <I>The War of the End of the World</I>. He lives in London.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus, and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1a6b14e4